import { render, staticRenderFns } from "./RadioboxBlank.vue?vue&type=template&id=5b10267a&functional=true&"
import script from "./RadioboxBlank.vue?vue&type=script&lang=js&"
export * from "./RadioboxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports